const promotionTypeEnum = Object.freeze({
    SMALL: 5,
    BIG: 10
});
export default promotionTypeEnum;
